import React from 'react';
import GalleryPickerComponent from './GalleryPickerComponent';

export default function PdfInputComponent(props) {
    return <GalleryPickerComponent extensions={['pdf']} {...props}/>
}
